import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  const colorMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50',
    accent: 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50',
    secondary: 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50',
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            专题合集
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            无论你喜欢什么类型，51影院都为你准备好了精选片单，点击探索你的光影世界
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group flex flex-col items-center gap-3 p-5 md:p-7 rounded-2xl bg-background-50 hover:bg-background-50 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <span className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl transition-all duration-300 text-xl md:text-2xl ${colorMap[item.color] || colorMap.primary}`}>
                <i className={item.icon}></i>
              </span>
              <span className="font-heading text-sm md:text-base font-semibold text-foreground-800">
                {item.title}
              </span>
              <span className="text-xs text-foreground-500 text-center leading-relaxed hidden md:block">
                {item.description}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}